import { ReactNode, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import Button from '~/shared/components/Buttons';
import ClipboardIcon from '~/shared/assets/icons/clipboard.svg';
import Typography from '~/shared/components/Typography';

import { CopiedTooltip } from './CopiedTooltip';

export function SectionFooter({
  infoProps: { variant = 'default', text },
  copyText,
  // buttonEl,
}: {
  infoProps: { variant?: 'default' | 'success' | 'error' | 'none'; text?: string | ReactNode };
  copyText?: string;
  buttonEl?: ReactNode;
}) {
  const [copied, setCopied] = useState('');
  const timeout = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!copied) {
      return;
    }
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      setCopied('');
      timeout.current = null;
    }, 750);
  }, [copied]);

  const variantsMap: Record<typeof variant, { text: string }> = {
    default: { text: 'text-gray-2' },
    success: { text: 'text-gray-2' },
    error: { text: 'text-red' },
    none: { text: 'text-gray-2' },
  };

  return (
    <div className="w-full flex items-center justify-between mt-[8px bg-re">
      {variant === 'none' ? (
        text
      ) : (
        <div
          className={clsx('flex items-center gap-[12px]', {
            'px-[15px py-[10px rounded-[4px]': variant && variant !== 'default',
          })}
        >
          <Typography variant="caption" color={variantsMap[variant]?.text} className="px-0.5 py-1">
            {text}
          </Typography>
        </div>
      )}
      {copyText && (
        <Button
          type="button"
          variant="secondary"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            navigator.clipboard.writeText(copyText).then(() => setCopied(copyText));
          }}
          className="w-[121px] gap-[10px] relative"
        >
          <div className="flex items-center gap-[10px]">
            <ClipboardIcon className="w-[24px] h-[24px] stroke-primary-900" />
            Copy
          </div>
        </Button>
      )}
    </div>
  );
}
